


























































































































































































import {ReferenceBook} from "@/core/models";
import {CbcMixin} from "@/modules/cbc/mixins";
import {Message, MessageTypeEnum, MessageTypeIndicEnum} from "@/modules/cbc/models";
import {CountryEnumMixin} from "@/modules/country/mixins/country-enum";
import {CountryEnum} from "@/modules/country/models";
import {Country} from "@/modules/country/models/dto.model";
import {LanguageEnumMixin} from "@/modules/language/mixins";
import {LanguageEnum} from "@/modules/language/models";
import {Language} from "@/modules/language/models/dto.model";
import _ from "lodash";
import moment from "moment";
import {Component, Mixins, Prop, Watch} from "vue-property-decorator";
import {validationMixin} from "vuelidate";
import {maxLength, minLength, required} from "vuelidate/lib/validators";

@Component({
	components: {},
	mixins: [validationMixin],
	validations: {
		message: {
			sendingEntityIn: {
				minLength: minLength(1),
				maxLength: maxLength(200)
			},
			jurisdiction: {
				required
			},
			jurisdictions: {
				required
			},
			type: {},
			language: {},
			warning: {
				maxLength: maxLength(4000)
			},
			contact: {
				maxLength: maxLength(4000)
			},
			refId: {},
			typeIndic: {},
			corrMessageRefId: {},
			reportingPeriod: {
				required
			},
			timestamp: {}
		}
	}
})
export default class MessageSpecComponent extends Mixins(CbcMixin, CountryEnumMixin, LanguageEnumMixin) {
	@Prop()
	public readonly readonly!: boolean;

	@Prop()
	public languages!: Language[];

	@Prop()
	public readonly countries!: Country[];

	@Prop({
		type: Object, default: () => {
			return {
				sendingEntityIn: "",
				jurisdiction: {} as CountryEnum,
				jurisdictions: [] as CountryEnum[],
				type: MessageTypeEnum.CBC,
				language: undefined,
				warning: "",
				contact: "",
				refId: "",
				typeIndic: undefined,
				corrMessageRefId: [] as string[],
				reportingPeriod: "",
				timestamp: ""
			} as Message;
		}
	})
	public readonly message!: Message;

	public get value(): Message {
		return this.message;
	}

	public set value(message: Message) {
		if (this.$v!.message!.$invalid) {
			this.$v!.message!.$touch();
		} else
			this.$emit("update:message", message);
	}

	@Watch("message", {deep: true})
	public onChanged(value: Message, oldValue: Message) {
		this.value = value;
	}

	@Watch("jurisdiction", {deep: true})
	public onJurisdictionChanged(value: Country, oldValue: Country) {
		if (value !== oldValue) this.refId = this.generateRefId();
	}

	@Watch("jurisdictions", {deep: true})
	public onJurisdictionsChanged(values: Country[], oldValues: Country[]) {
		if (values.some(x => !oldValues.some(y => y.alpha2Code === x.alpha2Code)) || oldValues.some(x => !values.some(y => y.alpha2Code === x.alpha2Code)))
			this.refId = this.generateRefId();
	}

	@Watch("reportingPeriod", {deep: true})
	public onReportingPeriodChanged(value: string, oldValue: string) {
		if (value !== oldValue) this.refId = this.generateRefId();
	}

	public reportingPeriodMenu: boolean = false;
	public timestampMenu: boolean = false;

	public get jurisdiction(): Country | undefined {
		if (this.value && !_.isUndefined(this.value.jurisdiction)) return this.countries.find(x => x.alpha2Code === CountryEnum[this.value.jurisdiction])!;
	}

	public set jurisdiction(country: Country | undefined) {
		if (this.value && country) this.save({
			jurisdiction: this.getCountryEnum(country)
		});
	}

	public get jurisdictions(): Country[] | undefined {
		if (this.value && !_.isUndefined(this.value.jurisdictions)) return this.countries.filter(x => this.value.jurisdictions.find(y => CountryEnum[y] === x.alpha2Code))!;
	}

	public set jurisdictions(countries: Country[] | undefined) {
		if (this.value && countries && countries.length > 0) this.save({
			jurisdictions: this.getCountryEnums(countries)
		});
	}

	public get language(): Language | undefined {
		if (this.value && !_.isUndefined(this.value.language)) {
			const languageEnum = LanguageEnum[this.value.language];
			return this.languages.find(x => x.code === languageEnum);
		}
	}

	public set language(language: Language | undefined) {
		if (this.value && language) this.save({language: this.getLanguageEnum(language)});
	}

	public get type(): ReferenceBook<MessageTypeEnum> | undefined {
		if (this.value && !_.isUndefined(this.value.type))
			return this.messageTypes.find(x => x.id === this.value.type)!;
	}

	public set type(type: ReferenceBook<MessageTypeEnum> | undefined) {
		if (this.value && type) this.save({type: type.id});
	}

	public get typeIndic(): ReferenceBook<MessageTypeIndicEnum> | undefined {
		if (this.value && !_.isUndefined(this.value.typeIndic)) return this.messageTypeIndics.find(x => x.id === this.value.typeIndic)!;
	}

	public set typeIndic(typeIndic: ReferenceBook<MessageTypeIndicEnum> | undefined) {
		if (this.value && typeIndic) this.save({typeIndic: typeIndic.id});
	}

	public get refId(): string | undefined {
		if (this.value) return this.value.refId;
	}

	public set refId(refId: string | undefined) {
		if (this.value && refId) this.save({refId: refId});
	}

	public get reportingPeriod(): string | undefined {
		if (this.value && this.value.reportingPeriod) {
			this.reportingPeriodText = moment(this.value.reportingPeriod).format("YYYY-MM-DD");
			return this.reportingPeriodText;
		}
	}

	public reportingPeriodText: string = "";

	public set reportingPeriod(reportingPeriod: string | undefined) {
		if (this.value && reportingPeriod) {
			this.save({reportingPeriod: reportingPeriod});
			this.reportingPeriodText = reportingPeriod;
		}
	}

	public get timestamp(): string | undefined {
		if (this.value && this.value.timestamp) {
			this.timestampText = moment(this.value.timestamp).toISOString();
			return this.timestampText;
		}
	}

	public timestampText: string = "";

	public set timestamp(timestamp: string | undefined) {
		if (this.value && timestamp) {
			this.save({timestamp: timestamp});
			this.timestampText = timestamp;
		}
	}

	public get sendingEntityInErrors() {
		const errors: string[] = [];
		if (!this.$v!.message!.sendingEntityIn!.$dirty) return errors;
		!this.$v!.message!.sendingEntityIn!.minLength && errors.push("The minimum of 1 character are allowed");
		!this.$v!.message!.sendingEntityIn!.maxLength && errors.push("The maximum of 200 characters are allowed");
		return errors;
	}

	public get jurisdictionErrors() {
		const errors: string[] = [];
		if (!this.$v!.message!.jurisdiction!.$dirty) return errors;
		!this.$v!.message!.jurisdiction!.required && errors.push("The Transmitting Country is required");
		return errors;
	}

	public get jurisdictionsErrors() {
		const errors: string[] = [];
		if (!this.$v!.message!.jurisdictions!.$dirty) return errors;
		!this.$v!.message!.jurisdictions!.required && errors.push("The Receiving Country is required");
		return errors;
	}

	public get languageErrors() {
		const errors: string[] = [];
		if (!this.$v!.message!.language!.$dirty) return errors;
		return errors;
	}

	public get warningErrors() {
		const errors: string[] = [];
		if (!this.$v!.message!.warning!.$dirty) return errors;
		!this.$v!.message!.warning!.maxLength && errors.push("The maximum of 4’000 characters are allowed");
		return errors;
	}

	public get contactErrors() {
		const errors: string[] = [];
		if (!this.$v!.message!.contact!.$dirty) return errors;
		!this.$v!.message!.contact!.maxLength && errors.push("The maximum of 4’000 characters are allowed");
		return errors;
	}

	public get reportingPeriodErrors() {
		const errors: string[] = [];
		if (!this.$v!.message!.reportingPeriod!.$dirty) return errors;
		!this.$v!.message!.reportingPeriod!.required && errors.push("The Reporting Period is required");
		return errors;
	}

	private save(message: Message | any) {
		this.value = Object.assign(this.value, message);
	}

	private generateRefId(): string {
		return this.onGenerateRefId(
			this.jurisdiction ? this.jurisdiction.alpha2Code : "",
			new Date(this.reportingPeriod!).getFullYear(),
			this.jurisdictions ? this.jurisdictions.map(x => x.alpha2Code).join("") : "",
			new Date());
	}
}
